import { render, staticRenderFns } from "./wageAppeal.vue?vue&type=template&id=b35cf8cc&scoped=true&"
import script from "./wageAppeal.vue?vue&type=script&lang=js&"
export * from "./wageAppeal.vue?vue&type=script&lang=js&"
import style0 from "./wageAppeal.vue?vue&type=style&index=0&id=b35cf8cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35cf8cc",
  null
  
)

export default component.exports